export default __webpack_public_path__ + "static/media/scheduler.7abb526b.jpg";